export const shop = {
  bot_model: "SHOP",
  annotations: [
    {
      key: "orderer",
      label: "訂購人資訊",
      value: "{{customer.DELIVERY_NAME}}",
      required: true,
      type: "ORDERER",
      validation: null,
      prerequisities: null,
      placeholder: "",
      isSystem: true,
    },
    {
      key: "payment",
      label: "Payment",
      value: "{{customer.PAYMENT_KEY}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: null,
      placeholder: "",
      sources: [
        { key: "CREDIT", label: "信用卡(一次付清)" },
        { key: "CREDIT_INSTALLMENT", label: "信用卡(分期付款)" },
        { key: "NEWEBPAY_LINEPAY", label: "LINE PAY \b" },
        { key: "CASH", label: "貨到付款" },
      ],
      isSystem: true,
    },
    {
      key: "delivery",
      label: "Delivery",
      value: "{{customer.DELIVERY_KEY}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: null,
      placeholder: "",
      sources: [
        { key: "HOME", label: "宅配" },
        { key: "SEVEN", label: "7-Eleven" },
        { key: "FAMILY", label: "全家" },
      ],
      isSystem: true,
    },
    {
      key: "installment_month",
      label: "分期付款期數",
      value: "{{customer.installment_month}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: [{ payment: "CREDIT_INSTALLMENT" }],
      placeholder: "",
      sources: [
        { key: "3", label: "3期" },
        { key: "6", label: "6期" },
      ],
      level: 2,
      isSystem: true,
    },
    {
      key: "address",
      label: "Address",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "INPUT",
      validation: null,
      prerequisities: [{ delivery: "HOME" }, { cash_type: "HOME" }],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "store_family",
      label: "全家門市",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "STORE_FAMILY",
      validation: null,
      prerequisities: [{ delivery: "FAMILY" }, { cash_type: "FAMILY" }],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "store_seven",
      label: "7-11門市",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "STORE_SEVEN",
      validation: null,
      prerequisities: [{ delivery: "SEVEN" }, { cash_type: "SEVEN" }],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
  ],
  shopSettings: {
    delivery_fee: {
      seven: 60,
      family: 60,
      home: 80,
      custom: null,
      maxfree: null,
    },
    domainName: "tiffany-eshop",
    hasAgent: false,
    landingPage: {
      category: {
        jewelry: 1120,
        bracelet: 1118,
        earrings: 1117,
        rings: 1119,
      },
      tag: {
        banners: "banners",
        festivalProduct: "禮品",
        newProduct: "新品推薦",
        specialProduct: "特別活動",
        recommedProduct: "送禮推薦",
        material: "材質",
        type: "產品系列",
      },
      home: {
        bannerSku: {
          images: [
            {
              id: 5229,
              title: "banners",
              redirectLink: "/icons/1695/list",
              isExternal: false,
              locale: {
                en: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-6a1fc277-6470-4638-842e-6226583a0d5c",
                th: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-6a1fc277-6470-4638-842e-6226583a0d5c",
                "zh-tw":
                  "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-6a1fc277-6470-4638-842e-6226583a0d5c",
              },
            },
          ],
          productsOrder: [6615, 6601],
          tagPrefix: "banners",
        },
        heroSku: {
          tagPrefix: "特別活動",
          sectionTitle: "hero_section_title",
          sectionSubTitle: "hero_section_sub_title",
          banners: [
            {
              id: "",
              desc: "0",
              title: "特別活動_Bulgari T_ON",
              url: "",
              redirectLink: "",
              isExternal: false,
            },
          ],
          productsOrder: [6614],
        },
        collectionSku: {
          tabs: [
            {
              tag: {
                id: 1694,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "B.ZERO1",
              title: "collection_tabs_0_title",
              order: 1,
              collectionTitle: "collection_tabs_0_title",
              collectionDesc: "collection_tabs_0_desc",
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-28b8c62a-6677-4995-8346-273e3e687d52",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
            {
              tag: {
                id: 1695,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "SERPENTI",
              title: "collection_tabs_1_title",
              order: 2,
              collectionTitle: "collection_tabs_1_title",
              collectionDesc: "collection_tabs_1_desc",
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-ebca692b-63d9-4e81-a2ec-8a925330827d",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
            {
              tag: {
                id: 1696,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "DIVAS’ DREAM",
              title: "collection_tabs_2_title",
              order: 3,
              collectionTitle: "collection_tabs_2_title",
              collectionDesc: "collection_tabs_2_desc",
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-d03702ff-8645-484e-b276-fde80e531d37",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
            {
              tag: {
                id: 1697,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "BVLGARI BVLGARI",
              title: "collection_tabs_3_title",
              order: 4,
              collectionTitle: "collection_tabs_3_title",
              collectionDesc: "collection_tabs_3_desc",
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-20cf0bf2-c1ce-48d8-8cf8-209aeedc80b3",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
            {
              tag: {
                id: 1698,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "TUBOGAS",
              title: "collection_tabs_4_title",
              order: 4,
              collectionTitle: "collection_tabs_4_title",
              collectionDesc: "collection_tabs_4_desc",
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-a9d7a5a1-f583-4bdd-a0c5-4bfdf93a75fd",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
            {
              tag: {
                id: 1699,
                title: "禮品_Bulgari Knot_ON",
              },
              key: "BVLGARI BVLGARI & OCTO WATCHES",
              title: "collection_tabs_5_title",
              order: 5,
              collectionTitle: "collection_tabs_5_title",
              collectionDesc: "collection_tabs_5_desc",
              banner: [
                {
                  url: "	https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-fb244136-0611-4ee7-baa3-34f62d1cb47e",
                  path: "/icons/1629/list",
                  isExternal: false,
                },
              ],
            },
          ],
          tagPrefix: "禮品",
          sectionTitle: "",
          sectionSubTitle: "",
        },
        categorySku: {
          tabs: [
            {
              category: {
                id: 1117,
                status: "ON",
              },
              id: 1117,
              key: "Necklaces",
              title: "category_tabs_0_title",
              order: 1,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-09c30998-c01a-4eb0-9fb0-40033a81241e",
                  path: null,
                  isExternal: null,
                },
              ],
            },
            {
              category: {
                id: 1118,
                status: "ON",
              },
              id: 1118,
              key: "Earrings",
              title: "category_tabs_1_title",
              order: 2,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-d90aa966-da4e-4762-8029-1d7dd7b10c70",
                  path: null,
                  isExternal: null,
                },
              ],
            },
            {
              category: {
                id: 1119,
                status: "ON",
              },
              id: 1119,
              key: "Rings",
              title: "category_tabs_1_title",
              order: 3,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-6afa372b-9d8c-4242-9075-cd6284d64c4c",
                  path: null,
                  isExternal: null,
                },
              ],
            },
            {
              category: {
                id: 1120,
                status: "ON",
              },
              id: 1120,
              key: "Bracelets",
              title: "category_tabs_2_title",
              order: 4,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-b013a92a-4cc9-40bb-bf86-cc6c13c3187d",
                  path: null,
                  isExternal: null,
                },
              ],
            },
            {
              category: {
                id: 1121,
                status: "ON",
              },
              id: 1121,
              key: "Watches",
              title: "category_tabs_1_title",
              order: 5,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-02c2a4f0-1d5b-4d25-9c4c-d0be3fc07f66",
                  path: null,
                  isExternal: null,
                },
              ],
            },
            {
              category: {
                id: 1122,
                status: "ON",
              },
              id: 1122,
              key: "Accessories & Others",
              title: "category_tabs_3_title",
              order: 6,
              banner: [
                {
                  url: "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-500bfbac-5e23-4641-bda5-371091d3fae6",
                  path: null,
                  isExternal: null,
                },
              ],
            },
          ],
          tagPrefix: "送禮推薦",
          sectionTitle: "category_section_title",
          sectionSubTitle: "category_section_sub_title",
        },
      },
      status: { ON: "ON", OFF: "OFF" },
      locale: [],
    },
    lineLoginChannelId: "1657533216",
    payment_flow: { installment_months: [3, 6] },
    enableDefaultReply: false,
    appreciationPeriod: 0,
  },
  branches: [],
  liff_id: "1657533216-Bl050mp6",
  delivery_flow: ["HOME", "SEVEN", "FAMILY"],
  payment_flow: ["CASH"],
  payment_services: ["NEWEBPAY"],
  contact_name: "Georg Jenson EC 測試帳號",
  contact_address: "",
  contact_email: "george-jensen-dev@hotmail.com",
  contact_phone: "0800-001-904",
  avatar: "",
  contact_href: "https://123",
  cod_target: ["HOME", "FAMILY", "SEVEN"],
  hasInvoice: true,
  categories: [
    {
      id: 1117,
      title: "Necklaces",
    },
    {
      id: 1118,
      title: "Earrings",
    },
    {
      id: 1119,
      title: "Rings",
    },
    {
      id: 1120,
      title: "Bracelets",
    },
    {
      id: 1121,
      title: "Watches",
    },
    {
      id: 1122,
      title: "Accessories & Others",
    },
  ],
  productTags: [
    {
      id: 1694,
      title: "B.ZERO1 & Save The Children",
    },
    {
      id: 1695,
      title: "SERPENTI",
    },
    {
      id: 1696,
      title: "DIVAS’ DREAM",
    },
    {
      id: 1697,
      title: "BVLGARI BVLGARI",
    },
    {
      id: 1698,
      title: "TUBOGAS",
    },
    {
      id: 1699,
      title: "BVLGARI BVLGARI & OCTO WATCHES",
    },
  ],
};

export const mockProducts = [
  {
    id: 6615,
    img_url: [
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-f1235bfa-a7bf-4cf8-a231-fed6f8812b1e",
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-77da82fd-2cec-4411-8b6f-62840dc8b62e",
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-676f55bb-2710-4498-b5c1-0fbe1470fc3b",
    ],
    description: "Rose Gold / Diamonds",
    name: "B.ZERO1 RING",
    tags: ["Online Exclusive"],
    specs: [
      {
        id: 14225,
        createtime: "2025-09-12T05:58:10.000Z",
        lastupdate: "2025-09-12T05:58:10.000Z",
        product_id: 6632,
        product_spec_uid: "",
        quantity: 15,
        amount: 108000,
        currency: "TWD",
        img_url: null,
        group_item: [],
        group_title: "",
        gtin: null,
        mpn: null,
        extra_info: null,
        type: "RETAIL",
        extendId: null,
        pointAmount: 0,
        tpPointAmount: 0,
        weight: 0,
      },
      {
        id: 14226,
        createtime: "2025-09-12T05:58:10.000Z",
        lastupdate: "2025-09-12T05:58:10.000Z",
        product_id: 6632,
        product_spec_uid: "",
        quantity: 15,
        amount: 98000,
        currency: "TWD",
        img_url: null,
        group_item: [],
        group_title: "",
        gtin: null,
        mpn: null,
        extra_info: null,
        type: "RETAIL",
        extendId: null,
        pointAmount: 0,
        tpPointAmount: 0,
        weight: 0,
      },
    ],
    spec_groups: [],
  },
  {
    id: 6616,
    img_url: [
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-77da82fd-2cec-4411-8b6f-62840dc8b62e",
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-f1235bfa-a7bf-4cf8-a231-fed6f8812b1e",
      "https://d1g2zqbrv1dxef.cloudfront.net/208/image/s00208-676f55bb-2710-4498-b5c1-0fbe1470fc3b",
    ],
    description: "Yellow Gold / No Gemstone",
    name: "B.ZERO1 RING",
    tags: ["Online Exclusive"],
    specs: [
      {
        id: 14225,
        createtime: "2025-09-12T05:58:10.000Z",
        lastupdate: "2025-09-12T05:58:10.000Z",
        product_id: 6632,
        product_spec_uid: "",
        quantity: 15,
        amount: 108000,
        currency: "TWD",
        img_url: null,
        group_item: [],
        group_title: "",
        gtin: null,
        mpn: null,
        extra_info: null,
        type: "RETAIL",
        extendId: null,
        pointAmount: 0,
        tpPointAmount: 0,
        weight: 0,
      },
      {
        id: 14226,
        createtime: "2025-09-12T05:58:10.000Z",
        lastupdate: "2025-09-12T05:58:10.000Z",
        product_id: 6632,
        product_spec_uid: "",
        quantity: 15,
        amount: 98000,
        currency: "TWD",
        img_url: null,
        group_item: [],
        group_title: "",
        gtin: null,
        mpn: null,
        extra_info: null,
        type: "RETAIL",
        extendId: null,
        pointAmount: 0,
        tpPointAmount: 0,
        weight: 0,
      },
    ],
  },
];

export const shuffle = (array) =>
  array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

export const history_orders = [
  {
    ID: 6408,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "未付款",
    ORDER_STATUS: "處理中",
    PAYMENT_STATUS: "未付款",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-09-14 14:32",
    AMOUNT: 22880,
    DELIVERY_FEE: 80,
    ITEMS: "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1",
    ITEM_NAME: "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1",
    FIRST_ITEM_ID: 4506,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796408",
    UPDATE_TIME: "2022-09-15T16:00:22.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4506,
        SPEC_ID: 10433,
        QUANTITY: 1,
        PRICE: 22800,
        PRODUCT: {
          id: 4506,
          createtime: "2022-06-15T11:32:13.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Serpenti Cabochon杜鵑石英粉色圓形迷你包",
          status: "ON",
          description:
            "Serpenti Cabochon 圓形迷你包，外側採用杜鵑石英粉色小牛皮，內側採用尖晶石洋紅色納帕軟面皮革，飾以幾何圖形設計的立體絎縫紋路，設計靈感來自蛋面型切割寶石的圓潤表面，奢華質感可讓任何穿搭瞬間升級。拉鍊開合，淡金色黃銅蛇頭拉鍊靈感源自Heritage典藏系列作品。配備皮革搭配金屬背帶。單一收納層。尺寸：11 x 11 x 2.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-2905bc77-46e8-42c6-a559-e543b348832a",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-cb676b90-d3a3-4187-831d-e553c5b482c2",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5f03b998-f281-4af3-bafb-41497f872b71",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-9c40049e-8508-45da-9c37-d619e74bb86e",
          ],
          order: 0,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10433,
            createtime: "2022-06-15T11:32:13.000Z",
            lastupdate: "2022-09-14T04:07:52.000Z",
            product_id: 4506,
            product_spec_uid: "292256",
            quantity: 10,
            amount: 22800,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6402,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "發貨中",
    ORDER_STATUS: "已確認",
    PAYMENT_STATUS: "已付款",
    DELIVERY_STATUS: "發貨中",
    TIME: "2022-09-14 12:11",
    AMOUNT: 134680,
    DELIVERY_FEE: 80,
    ITEMS: "Divas’ Dream七夕特別版項鍊 x 1",
    ITEM_NAME: "Divas’ Dream七夕特別版項鍊 x 1",
    FIRST_ITEM_ID: 4561,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796402",
    UPDATE_TIME: "2022-09-14T04:11:41.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4561,
        SPEC_ID: 10497,
        QUANTITY: 1,
        PRICE: 134600,
        PRODUCT: {
          id: 4561,
          createtime: "2022-06-17T09:50:59.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 534,
          product_uid: "",
          name: "Divas’ Dream七夕特別版項鍊",
          status: "ON",
          description: "2022七夕情人節特別款，珍珠母貝與粉紅剛玉項鍊。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-3b0f1b29-d734-41c8-a701-2722204c5c7b",
          ],
          order: 0,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10497,
            createtime: "2022-06-17T09:50:59.000Z",
            lastupdate: "2022-07-02T16:00:21.000Z",
            product_id: 4561,
            product_spec_uid: "359938",
            quantity: 1,
            amount: 134600,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: "li8f24cb128bf7456db2",
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6401,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "發貨中",
    ORDER_STATUS: "已確認",
    PAYMENT_STATUS: "已付款",
    DELIVERY_STATUS: "發貨中",
    TIME: "2022-09-14 12:09",
    AMOUNT: 16680,
    DELIVERY_FEE: 80,
    ITEMS: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾 x 1",
    ITEM_NAME: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾 x 1",
    FIRST_ITEM_ID: 4495,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796401",
    UPDATE_TIME: "2022-09-14T04:10:02.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4495,
        SPEC_ID: 10422,
        QUANTITY: 1,
        PRICE: 16600,
        PRODUCT: {
          id: 4495,
          createtime: "2022-06-15T08:59:45.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾",
          status: "ON",
          description:
            "Bvlgari Logo 小巧皮夾，外側採用珊瑚橘色小牛皮，飾以 Infinitum Bulgari 連續燙印圖案。內側採用粉紅石英色納帕軟面皮革，按扣開合。5 個信用卡夾層，1 個薄夾層，1 個拉鍊零錢格，1 個鈔票夾層。尺寸：11 x 8.5 x 2.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-449c4bdd-e311-42eb-af30-35fe41961122",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-41bd1eac-fdf1-4b4c-bf9a-e1adfe9de6c8",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-b31584c6-0eb9-45a2-b1d7-e1b44cf9c640",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5ce5c89f-d16b-48b0-9d84-0e24abd09e91",
          ],
          order: 53,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10422,
            createtime: "2022-06-15T08:59:45.000Z",
            lastupdate: "2022-09-14T04:08:19.000Z",
            product_id: 4495,
            product_spec_uid: "292058",
            quantity: 1,
            amount: 16600,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: "li513d4446b31a414fbc",
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6400,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "已取消",
    ORDER_STATUS: "已取消",
    PAYMENT_STATUS: "已過期",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-09-14 12:08",
    AMOUNT: 16680,
    DELIVERY_FEE: 80,
    ITEMS: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾 x 1",
    ITEM_NAME: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾 x 1",
    FIRST_ITEM_ID: 4495,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "ATM",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796400",
    UPDATE_TIME: "2022-09-15T16:00:21.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4495,
        SPEC_ID: 10422,
        QUANTITY: 1,
        PRICE: 16600,
        PRODUCT: {
          id: 4495,
          createtime: "2022-06-15T08:59:45.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Bvlgari Logo珊瑚橘色小牛皮小巧皮夾",
          status: "ON",
          description:
            "Bvlgari Logo 小巧皮夾，外側採用珊瑚橘色小牛皮，飾以 Infinitum Bulgari 連續燙印圖案。內側採用粉紅石英色納帕軟面皮革，按扣開合。5 個信用卡夾層，1 個薄夾層，1 個拉鍊零錢格，1 個鈔票夾層。尺寸：11 x 8.5 x 2.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-449c4bdd-e311-42eb-af30-35fe41961122",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-41bd1eac-fdf1-4b4c-bf9a-e1adfe9de6c8",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-b31584c6-0eb9-45a2-b1d7-e1b44cf9c640",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5ce5c89f-d16b-48b0-9d84-0e24abd09e91",
          ],
          order: 53,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10422,
            createtime: "2022-06-15T08:59:45.000Z",
            lastupdate: "2022-06-23T10:36:33.000Z",
            product_id: 4495,
            product_spec_uid: "292058",
            quantity: 2,
            amount: 16600,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6399,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "已取消",
    ORDER_STATUS: "已取消",
    PAYMENT_STATUS: "已過期",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-09-14 12:07",
    AMOUNT: 22880,
    DELIVERY_FEE: 80,
    ITEMS: "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1",
    ITEM_NAME: "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1",
    FIRST_ITEM_ID: 4506,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796399",
    UPDATE_TIME: "2022-09-15T16:00:20.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4506,
        SPEC_ID: 10433,
        QUANTITY: 1,
        PRICE: 22800,
        PRODUCT: {
          id: 4506,
          createtime: "2022-06-15T11:32:13.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Serpenti Cabochon杜鵑石英粉色圓形迷你包",
          status: "ON",
          description:
            "Serpenti Cabochon 圓形迷你包，外側採用杜鵑石英粉色小牛皮，內側採用尖晶石洋紅色納帕軟面皮革，飾以幾何圖形設計的立體絎縫紋路，設計靈感來自蛋面型切割寶石的圓潤表面，奢華質感可讓任何穿搭瞬間升級。拉鍊開合，淡金色黃銅蛇頭拉鍊靈感源自Heritage典藏系列作品。配備皮革搭配金屬背帶。單一收納層。尺寸：11 x 11 x 2.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-2905bc77-46e8-42c6-a559-e543b348832a",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-cb676b90-d3a3-4187-831d-e553c5b482c2",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5f03b998-f281-4af3-bafb-41497f872b71",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-9c40049e-8508-45da-9c37-d619e74bb86e",
          ],
          order: 0,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10433,
            createtime: "2022-06-15T11:32:13.000Z",
            lastupdate: "2022-09-14T03:59:53.000Z",
            product_id: 4506,
            product_spec_uid: "292256",
            quantity: 11,
            amount: 22800,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6398,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "已取消",
    ORDER_STATUS: "已取消",
    PAYMENT_STATUS: "已過期",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-09-14 11:59",
    AMOUNT: 43880,
    DELIVERY_FEE: 80,
    ITEMS:
      "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1\nSerpenti Forever亮澤杜鵑石英粉色薄型小巧皮夾 x 1",
    ITEM_NAME: "Serpenti Cabochon杜鵑石英粉色圓形迷你包 x 1",
    FIRST_ITEM_ID: 4506,
    QUANTITY: 2,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "ATM",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202209140796398",
    UPDATE_TIME: "2022-09-15T16:00:16.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4506,
        SPEC_ID: 10433,
        QUANTITY: 1,
        PRICE: 22800,
        PRODUCT: {
          id: 4506,
          createtime: "2022-06-15T11:32:13.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Serpenti Cabochon杜鵑石英粉色圓形迷你包",
          status: "ON",
          description:
            "Serpenti Cabochon 圓形迷你包，外側採用杜鵑石英粉色小牛皮，內側採用尖晶石洋紅色納帕軟面皮革，飾以幾何圖形設計的立體絎縫紋路，設計靈感來自蛋面型切割寶石的圓潤表面，奢華質感可讓任何穿搭瞬間升級。拉鍊開合，淡金色黃銅蛇頭拉鍊靈感源自Heritage典藏系列作品。配備皮革搭配金屬背帶。單一收納層。尺寸：11 x 11 x 2.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-2905bc77-46e8-42c6-a559-e543b348832a",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-cb676b90-d3a3-4187-831d-e553c5b482c2",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5f03b998-f281-4af3-bafb-41497f872b71",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-9c40049e-8508-45da-9c37-d619e74bb86e",
          ],
          order: 0,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10433,
            createtime: "2022-06-15T11:32:13.000Z",
            lastupdate: "2022-07-02T16:00:24.000Z",
            product_id: 4506,
            product_spec_uid: "292256",
            quantity: 12,
            amount: 22800,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
      {
        PRODUCT_ID: 4621,
        SPEC_ID: 10663,
        QUANTITY: 1,
        PRICE: 21000,
        PRODUCT: {
          id: 4621,
          createtime: "2022-06-21T11:02:57.000Z",
          lastupdate: "2022-07-16T07:02:36.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Serpenti Forever亮澤杜鵑石英粉色薄型小巧皮夾",
          status: "ON",
          description:
            "Serpenti Forever 薄型小巧皮夾，外側採用杜鵑石英粉色亮澤小牛皮，內側採用黑色小牛皮，經典蛇頭扣環的彩色蛇鱗和設計靈感來自 60 年代的 Serpenti 珠寶。按扣開合，背面外側設有 1 個拉鍊零錢格，4 個卡片夾層，1 個鈔票夾層，背面鑲有 BVLGARI 金屬標誌。尺寸：9.5 x 7.5 x 3 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: 0,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-4b1510f3-2198-4fd2-af5d-55aae32bf84b",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5a51b2e3-f52f-42a3-a3a2-aeff2b5259ba",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-e77f755e-03e1-4a09-8e2c-54aba317878d",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-54e71b6e-ad28-4c08-8aa5-4a7d4f6fa513",
          ],
          order: 3,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 10 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10663,
            createtime: "2022-06-21T11:02:57.000Z",
            lastupdate: "2022-06-21T11:02:57.000Z",
            product_id: 4621,
            product_spec_uid: "291973",
            quantity: 1,
            amount: 21000,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-09-15 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
      },
    ],
    LINE_SHOPPING: true,
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6347,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "發貨中",
    ORDER_STATUS: "已確認",
    PAYMENT_STATUS: "已付款",
    DELIVERY_STATUS: "發貨中",
    TIME: "2022-07-01 12:53",
    AMOUNT: 127280,
    DELIVERY_FEE: 80,
    ITEMS:
      "Serpenti Hobo炫目鑽石色迷你新月包 x 1\nSerpenti Forever Maxi Chain薄霧灰蛋白石色斜背包 x 1",
    ITEM_NAME: "Serpenti Hobo炫目鑽石色迷你新月包 x 1",
    FIRST_ITEM_ID: 4514,
    QUANTITY: 2,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡(分期付款)",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202207010796347",
    UPDATE_TIME: "2022-07-01T04:54:03.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 4514,
        SPEC_ID: 10443,
        QUANTITY: 1,
        PRICE: 37700,
        PRODUCT: {
          id: 4514,
          createtime: "2022-06-17T04:16:01.000Z",
          lastupdate: "2022-06-17T05:06:10.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "Serpenti Hobo炫目鑽石色迷你新月包",
          status: "ON",
          description:
            "Serpenti Hobo炫目鑽石色粒面小牛皮迷你新月包，搭配焦糖石英色羅緞內襯。蛇頭釦環設計靈感源自Heritage典藏系列作品，蛇首鑲嵌珍珠母貝裝飾，蛇眼鑲飾紅色琺瑯，附皮革與鍊帶肩背帶，皮帶磁釦與拉鍊開合，背面設有 1 個夾層。尺寸：13 x 8 x 3.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-54d5a349-b176-49ba-a7f1-367c920a260b",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-def15abd-d68b-4fe2-baa9-2c55e7c67e14",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-3fae78b5-1d56-4a8b-9954-ba4ff5d163ab",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-5ef42db5-d9c9-4efd-a074-0ac1d407d639",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-957b83a4-0460-4fff-8b7a-fc5dd7cb1049",
          ],
          order: 99999,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 5 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10443,
            createtime: "2022-06-17T04:16:01.000Z",
            lastupdate: "2022-06-23T16:00:14.000Z",
            product_id: 4514,
            product_spec_uid: "292288",
            quantity: 6,
            amount: 37700,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
      {
        PRODUCT_ID: 4526,
        SPEC_ID: 10457,
        QUANTITY: 1,
        PRICE: 89700,
        PRODUCT: {
          id: 4526,
          createtime: "2022-06-17T05:16:18.000Z",
          lastupdate: "2022-06-17T05:16:18.000Z",
          shop_id: 79,
          category_id: 514,
          product_uid: "",
          name: "Serpenti Forever Maxi Chain薄霧灰蛋白石色斜背包",
          status: "ON",
          description:
            "Serpenti Forever Maxi Chain 小斜背包，捕捉現代日常的奢華精神，採用柔韌的薄霧灰蛋白石色 Metropolitan 小牛皮，Heritage 蛇頭磁扣鑲飾寶石，設計靈感來自 1960 年代的 Bulgari 腕錶。注入品牌的大膽珠寶基因，一條粗鍊宛如項鍊垂掛在掀蓋上，可當做手柄使用。附皮革肩背帶，1 個收納層，正面設有 1 個夾層，背面設有 1 個貼式夾層，1 個客製化妝鏡，背面鑲有 BULGARI 金屬標誌。尺寸：20 x 15 x 8.5 公分。義大利製造。",
          detail: "",
          product_url: "",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-3301f1f6-c8bd-4c6b-9542-d0cb1f2b39e8",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-2a20e0f5-e000-4f87-a266-f2bf13354e50",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-2af4b704-7708-4e0b-8d1d-eb46933580fa",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-dd21c367-34a7-4e9a-b59a-eb350724d358",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-25dd913e-6393-4f7f-8376-9cdf017db066",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-8311dadd-b1bb-4f12-9684-2f6f5619ea67",
            "https://dak6ovdfbyw15.cloudfront.net/img/s00256-d44ccb2c-3c8f-481a-85f2-5ab9166766f9",
          ],
          order: 99999,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 5 } },
          isPeriod: false,
          allowDecimal: false,
          tags: [],
          spec: {
            id: 10457,
            createtime: "2022-06-17T05:16:18.000Z",
            lastupdate: "2022-06-17T05:16:18.000Z",
            product_id: 4526,
            product_spec_uid: "292031",
            quantity: 3,
            amount: 89700,
            currency: "TWD",
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-07-02 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        value: "BV200",
        required: false,
        type: "COUPON",
      },
      {
        key: "installment_month",
        label: "分期付款期數",
        value: "3",
        required: false,
        type: "OPTIONS",
        sources: [{ key: "3", label: "3期" }],
      },
    ],
    LINE_SHOPPING: true,
    COUPON: "測試折扣碼-200",
    NEXT_PERIOD: "-",
    TRANSACTION_ID: "li6c77f02fcf934cba9c",
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6274,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "發貨中",
    ORDER_STATUS: "已確認",
    PAYMENT_STATUS: "已付款",
    DELIVERY_STATUS: "發貨中",
    TIME: "2022-06-15 10:19",
    AMOUNT: 50780,
    DELIVERY_FEE: 80,
    ITEMS: "SERPENTI FOREVER 祖母綠色小牛皮鏈帶皮夾 x 1",
    ITEM_NAME: "SERPENTI FOREVER 祖母綠色小牛皮鏈帶皮夾 x 1",
    FIRST_ITEM_ID: 2040,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡(分期付款)",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202206150796274",
    UPDATE_TIME: "2022-06-15T02:20:16.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 2040,
        SPEC_ID: 4963,
        QUANTITY: 1,
        PRICE: 50700,
        PRODUCT: {
          id: 2040,
          createtime: "2021-06-04T09:47:53.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "SERPENTI FOREVER 祖母綠色小牛皮鏈帶皮夾",
          status: "ON",
          description:
            "蛇頭包最經典的顏色，祖母綠，鑲有細膩彩色琺瑯的蛇頭如同珠寶般細緻。290837",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>Serpenti Forever 祖母綠色小牛皮鍊帶皮夾，內側採用黑色 Nappa 軟面皮，淡金色黃銅配飾。獨特蛇頭按扣飾以黑色和淨白瑪瑙色珠光琺瑯，蛇眼鑲飾黑色縞瑪瑙，附可拆可調式皮革鍊帶，整體設計精巧出色。</p><p>1 個內格收納層，6 個信用卡夾層，1 個拉鍊夾層。20 x 12 x 4 公分 - 7.9 x 4.7 x 1.5 吋。</p><p><br></p><p>在古希臘羅馬神話中，蛇象徵的是智慧、生命力，以及生命的生生不息。寶格麗以全新設計和獨特材質重新詮釋，帶來大膽魅力和繽紛色彩，鑲有細膩彩色琺瑯的蛇頭如同珠寶般細緻。</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/2040",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s25643_210604094454995",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25644_210604094454999",
            "https://dak6ovdfbyw15.cloudfront.net/img/s2560_210604094455004",
            "https://dak6ovdfbyw15.cloudfront.net/img/s2561_210604094455002",
          ],
          order: 2,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4963,
            createtime: "2021-06-04T09:47:53.000Z",
            lastupdate: "2021-06-04T09:47:53.000Z",
            product_id: 2040,
            product_spec_uid: "290837",
            quantity: 20,
            amount: 50700,
            currency: null,
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-06-16 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
        sources: null,
      },
      {
        key: "installment_month",
        label: "分期付款期數",
        value: "18",
        required: false,
        type: "OPTIONS",
        sources: [
          { key: "3", label: "3期" },
          { key: "6", label: "6期" },
          { key: "12", label: "12期" },
          { key: "18", label: "18期" },
        ],
      },
    ],
    NEXT_PERIOD: "-",
    TRANSACTION_ID: "lif9d540c901ff4b9d80",
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6271,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "發貨中",
    ORDER_STATUS: "已確認",
    PAYMENT_STATUS: "已付款",
    DELIVERY_STATUS: "發貨中",
    TIME: "2022-06-15 10:14",
    AMOUNT: 152080,
    DELIVERY_FEE: 80,
    ITEMS: "B.zero1 18K白金項鍊 -新款長鍊版 x 1",
    ITEM_NAME: "B.zero1 18K白金項鍊 -新款長鍊版 x 1",
    FIRST_ITEM_ID: 2023,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "信用卡",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202206150796271",
    UPDATE_TIME: "2022-06-15T02:16:31.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 2023,
        SPEC_ID: 4941,
        QUANTITY: 1,
        PRICE: 152000,
        PRODUCT: {
          id: 2023,
          createtime: "2021-06-03T08:00:12.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 534,
          product_uid: "",
          name: "B.zero1 18K白金項鍊 -新款長鍊版",
          status: "ON",
          description:
            "鍊長54-60 cm。B.zero1系列，打破珠寶設計常規，是獨特個性、創意表達的大膽象徵。 - 358347",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>【B.zero1 ! Be Yourself !】 </p><p><br></p><p>靈感來自於羅馬圓形競技場的寶格麗經典珠寶 B.zero1系列，打破珠寶設計常規，是獨特個性、創意表達的大膽象徵。</p><p><br></p><p>B代表品牌縮寫，Zero.1代表 0和1，「新生」與「永恆」，是承接過去、創造現在與延續未來的符碼!</p><p><br></p><p>鍊長54-60 cm。</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/2023",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s25662_210603075915281",
            "https://dak6ovdfbyw15.cloudfront.net/img/s2569_210603075915283",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25636_210603075915278",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25610_210603075915284",
            "https://dak6ovdfbyw15.cloudfront.net/img/s2566_210603075915286",
          ],
          order: 8,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4941,
            createtime: "2021-06-03T08:00:12.000Z",
            lastupdate: "2022-06-14T15:53:26.000Z",
            product_id: 2023,
            product_spec_uid: "358347",
            quantity: 20,
            amount: 152000,
            currency: null,
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-06-16 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
        sources: null,
      },
    ],
    NEXT_PERIOD: "-",
    TRANSACTION_ID: "li0f91cd9c74964ea3b2",
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6269,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "已取消",
    ORDER_STATUS: "已取消",
    PAYMENT_STATUS: "已過期",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-06-15 10:09",
    AMOUNT: 13180,
    DELIVERY_FEE: 80,
    ITEMS: "SERPENTI FOREVER 祖母綠色卡夾 x 1",
    ITEM_NAME: "SERPENTI FOREVER 祖母綠色卡夾 x 1",
    FIRST_ITEM_ID: 2039,
    QUANTITY: 1,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "ATM",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202206150796269",
    UPDATE_TIME: "2022-06-21T16:00:16.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 2039,
        SPEC_ID: 4962,
        QUANTITY: 1,
        PRICE: 13100,
        PRODUCT: {
          id: 2039,
          createtime: "2021-06-04T09:43:16.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "SERPENTI FOREVER 祖母綠色卡夾",
          status: "ON",
          description: "SERPENTI FOREVER 祖母綠色卡夾 280415",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>翠綠色小牛皮及淺紫晶色小牛皮兩折式信用卡夾。淡金色黃銅配飾，按扣開合。</p><p>Serpenti 蛇頭墜鍊飾以黑白琺瑯，蛇眼飾以孔雀石綠琺瑯。</p><p><br></p><p>在古希臘羅馬神話中，蛇象徵的是智慧、生命力，以及生命的生生不息。寶格麗以全新設計和獨特材質重新詮釋，帶來大膽魅力和繽紛色彩，鑲有細膩彩色琺瑯的蛇頭如同珠寶般細緻。</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/2039",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s2560_210604094200485",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25655_210604094200489",
          ],
          order: 3,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4962,
            createtime: "2021-06-04T09:43:16.000Z",
            lastupdate: "2022-06-15T02:07:48.000Z",
            product_id: 2039,
            product_spec_uid: "280415",
            quantity: 19,
            amount: 13100,
            currency: null,
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-06-16 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
        sources: null,
      },
    ],
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
  {
    ID: 6268,
    LINEID: "U4491bd05a18829abfe61e6aaf46c097d",
    STATUS: "已取消",
    ORDER_STATUS: "已取消",
    PAYMENT_STATUS: "已過期",
    DELIVERY_STATUS: "尚未出貨",
    TIME: "2022-06-15 10:07",
    AMOUNT: 325980,
    DELIVERY_FEE: 80,
    ITEMS:
      "【七夕首推】Divas' Dream 玫瑰金鑽石與粉紅剛玉項鍊 x 2\nSERPENTI FOREVER 祖母綠色卡夾 x 1\nBB MAN 皮革編織銀手環 - 黑/翡翠色(M ) x 1",
    ITEM_NAME: "【七夕首推】Divas' Dream 玫瑰金鑽石與粉紅剛玉項鍊 x 2",
    FIRST_ITEM_ID: 1908,
    QUANTITY: 4,
    ADDRESS: "Address",
    ACCOUNT_INFO: "12345",
    PAYMENT: "ATM",
    TO_NAME: "Rose",
    SHIPPING_NO: null,
    DELIVERY: "宅配",
    META: " ",
    UID: "202206150796268",
    UPDATE_TIME: "2022-06-21T16:00:16.000Z",
    ORDER_DETAILS: [
      {
        PRODUCT_ID: 1908,
        SPEC_ID: 4804,
        QUANTITY: 2,
        PRICE: 292600,
        PRODUCT: {
          id: 1908,
          createtime: "2021-05-11T08:16:44.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 534,
          product_uid: "",
          name: "【七夕首推】Divas' Dream 玫瑰金鑽石與粉紅剛玉項鍊",
          status: "ON",
          description:
            "鍊長38-45 cm。細膩挑選的粉紅剛玉，展現女神優雅魅力，18K玫瑰金，鑽石與粉紅剛玉項鍊 ",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>【Divas\' Dream 女神系列】&nbsp;</p><p><br></p><p>設計理念來自女神的優雅與羅馬永恆之城的靈感。</p><p><br></p><p>Divas\' Dream 設計精緻，充滿女性魅力，捕捉羅馬卡拉卡拉浴場的大理石色彩和扇形馬賽克的性感弧線，如女人飛揚的裙襬，展現義大利之美的精髓。</p><p><br></p><p>玫瑰金項鍊，鑲嵌1顆圓形明亮切割鑽石，27顆圓形切割粉紅剛玉 (總重約0.57克拉)，51顆圓形切割與密鑲鑽石。鍊長38-45 cm</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/1908",
          amount: 0,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s2560_210511081536140",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25610_210511081536144",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25612_210511081536150",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25641_210511081536147",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25614_210511081536148",
          ],
          order: 0,
          hot_order: 1,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4804,
            createtime: "2021-05-11T08:16:44.000Z",
            lastupdate: "2022-06-14T14:19:05.000Z",
            product_id: 1908,
            product_spec_uid: "358436",
            quantity: 20,
            amount: 146300,
            currency: null,
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
      {
        PRODUCT_ID: 2039,
        SPEC_ID: 4962,
        QUANTITY: 1,
        PRICE: 13100,
        PRODUCT: {
          id: 2039,
          createtime: "2021-06-04T09:43:16.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "SERPENTI FOREVER 祖母綠色卡夾",
          status: "ON",
          description: "SERPENTI FOREVER 祖母綠色卡夾 280415",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>翠綠色小牛皮及淺紫晶色小牛皮兩折式信用卡夾。淡金色黃銅配飾，按扣開合。</p><p>Serpenti 蛇頭墜鍊飾以黑白琺瑯，蛇眼飾以孔雀石綠琺瑯。</p><p><br></p><p>在古希臘羅馬神話中，蛇象徵的是智慧、生命力，以及生命的生生不息。寶格麗以全新設計和獨特材質重新詮釋，帶來大膽魅力和繽紛色彩，鑲有細膩彩色琺瑯的蛇頭如同珠寶般細緻。</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/2039",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s2560_210604094200485",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25655_210604094200489",
          ],
          order: 3,
          hot_order: 99999,
          spec_groups: [],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4962,
            createtime: "2021-06-04T09:43:16.000Z",
            lastupdate: "2022-06-14T14:19:05.000Z",
            product_id: 2039,
            product_spec_uid: "280415",
            quantity: 20,
            amount: 13100,
            currency: null,
            img_url: null,
            group_item: [],
            group_title: "",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
      {
        PRODUCT_ID: 2057,
        SPEC_ID: 4982,
        QUANTITY: 1,
        PRICE: 20200,
        PRODUCT: {
          id: 2057,
          createtime: "2021-06-07T03:40:13.000Z",
          lastupdate: "2022-05-30T17:25:09.000Z",
          shop_id: 79,
          category_id: 515,
          product_uid: "",
          name: "BB MAN 皮革編織銀手環 - 黑/翡翠色",
          status: "ON",
          description:
            "網路精品店獨家限定\r\n現代簡潔設計，搭配正裝休閒皆有型!",
          detail:
            '<div class="ql-snow"><div class="ql-editor"><p>BVLGARI BVLGARI MAN 編織小牛皮銀手環</p><p>現代簡潔設計，搭配正裝休閒皆有型!</p><p><br></p><p>290163 - Size M: 17,5 cm - 6.9吋 </p><p>290162 - Size L: 18,5 cm - 7.3吋</p></div></div>',
          product_url: "https://liff.line.me/1657215951-3On6O501/product/2057",
          amount: null,
          discount_rule: null,
          unit: "個",
          remark: {},
          quantity: 0,
          img_url: [
            "https://dak6ovdfbyw15.cloudfront.net/img/s2561_210607033645810",
            "https://dak6ovdfbyw15.cloudfront.net/img/s25631_210607033645813",
          ],
          order: 8,
          hot_order: 99999,
          spec_groups: [
            { group_title: "BB MAN皮革手環", group_items: ["M ", "L"] },
          ],
          extra_info: { lineShopping: { percentage: 0 } },
          isPeriod: false,
          allowDecimal: null,
          tags: [],
          spec: {
            id: 4982,
            createtime: "2021-06-07T03:46:15.000Z",
            lastupdate: "2021-06-07T03:46:15.000Z",
            product_id: 2057,
            product_spec_uid: "290163",
            quantity: 20,
            amount: 20200,
            currency: null,
            img_url: null,
            group_item: [0],
            group_title: "M ",
            gtin: null,
            mpn: null,
            extra_info: null,
          },
        },
      },
    ],
    EXPIRE_TIME: "2022-06-16 23:59",
    ANNOTATIONS: [
      {
        key: "coupon",
        label: "折扣碼",
        required: false,
        type: "COUPON",
        sources: null,
      },
    ],
    NEXT_PERIOD: "-",
    TRANSACTION_ID: null,
    POINT: 0,
    REWARD_POINT: 0,
  },
];

export const mock_customer = {
  id: 1451,
  createtime: "2022-09-30T00:35:51.000Z",
  lastupdate: "2022-09-30T03:03:26.000Z",
  chatapp_type: "LINE",
  shop_id: 87,
  name: "Stanley 世豪",
  fullname: "stan",
  email: "",
  phone: "0921133479",
  address: "addr",
  payment_flow: "CREDIT",
  remit_account: "",
  delivery_flow: "HOME",
  extra_info: {
    agree: { value: false, timestamp: 0 },
    annotations: {},
  },
  point: 0,
  last_order: "6436",
  orders: [
    {
      id: 6436,
      createtime: "2022-09-30T03:03:24.000Z",
      lastupdate: "2022-09-30T03:03:24.000Z",
      customer_id: 1451,
      shop_id: 87,
      couponLinkId: 0,
      refundId: null,
      order_uid: "202209300876436",
      invoice_num: null,
      transition_id: null,
      status: "UNPAID",
      orderStatus: "PENDING",
      logisticStatus: "PACKING",
      paymentStatus: "UNPAID",
      address: "addr",
      amount: 74980,
      currency: "TWD",
      recipient_name: "stan",
      phone: "0921133479",
      createFrom: "LINE",
      payment_flow: "CREDIT",
      paymentService: null,
      remit_account: "",
      delivery_flow: "HOME",
      discount_rule: null,
      remark: "",
      note: null,
      shipping_no: null,
      delivery_fee: 80,
      extra_fee: 0,
      is_expired: false,
      expiretime: "2022-10-01T15:59:59.000Z",
      is_archive: false,
      isError: false,
      annotations: [
        {
          key: "payment",
          label: "付款方式",
          value: "CREDIT",
          required: false,
          type: "OPTIONS",
          sources: [{ key: "FACE", label: "PICK UP" }],
        },
        {
          key: "delivery",
          label: "配送方式",
          value: "HOME",
          required: false,
          type: "OPTIONS",
          sources: [
            { key: "FACE", label: "面交" },
            { key: "FAMILY", label: "全家" },
            { key: "HOME", label: "宅配" },
            { key: "SEVEN", label: "7-Eleven" },
          ],
        },
        {
          key: "coupon",
          label: "折扣碼",
          required: false,
          type: "COUPON",
          sources: null,
        },
      ],
      discount: null,
      paymentInfo: null,
      point: 0,
      orderDetails: [
        {
          id: 6925,
          createtime: "2022-09-30T03:03:25.000Z",
          lastupdate: "2022-09-30T03:03:25.000Z",
          order_id: 6436,
          detail_uid: "20220930087643601",
          product_id: 4638,
          spec_id: 10695,
          quantity: 1,
          amount: 66500,
          currency: "TWD",
          product: {
            id: 4638,
            createtime: "2022-09-15T08:36:40.000Z",
            lastupdate: "2022-09-15T08:43:21.000Z",
            shop_id: 87,
            category_id: 1118,
            product_uid: null,
            name: "FUSION 手鏈",
            status: "ON",
            description:
              "完全密鑲完美切工的鑽石的 18K 白金戒指，置於一條細鏈上，構成了這款精緻的 Fusion 手鏈。 串飾由兩個小的扣環固定，並可調整長度以貼合手腕。",
            detail:
              '<div class="ql-snow"><div class="ql-editor"><p><span style="color: rgb(31, 40, 55);">商品依據庫存所在地不同，配送時間約 2-4 個工作 周.</span></p><p><span style="color: rgb(159, 154, 141);">9/8~9/19</span></p><p><span style="color: rgb(159, 154, 141);">新品/單鑽除外，結帳輸碼【GJ99】享全館8%回饋</span></p><p><span style="color: rgb(159, 154, 141);">九月購買K金珠寶，加贈GJ時尚行李吊牌(限30組)</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">完全密鑲完美切工的鑽石的 18K 白金戒指，置於一條細鏈上，構成了這款精緻的 Fusion 手鏈。 串飾由兩個小的扣環固定，並可調整長度以貼合手腕。</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">- 產品詳細說明</span></p><ul><li><span style="color: rgb(115, 37, 37);">商品編號：20001071</span></li><li><span style="color: black;">材質：18 K白金</span></li><li><span style="color: black;">寶石：鑽石0.16 ct</span></li><li><span style="color: black;">外形尺寸：寬：6 毫米。 長：190 毫米。 直徑：8 毫米。</span></li><li><span style="color: black;">設計年份：2022</span></li><li><span style="color: black;">系列：</span><a href="https://www.georgjensen.com/zh-tw/jewellery/fusion" rel="noopener noreferrer" target="_blank" style="color: black;">Fusion系列</a></li><li><span style="color: black;">探索：</span><a href="https://www.georgjensen.com/zh-tw/jewellery/gold-bracelets-and-bangles" rel="noopener noreferrer" target="_blank" style="color: black;">Gold bracelets and bangles</a><span style="color: black;">,&nbsp;</span><a href="https://www.georgjensen.com/zh-tw/jewellery/diamond-bracelets-and-bangles" rel="noopener noreferrer" target="_blank" style="color: black;">Diamond bracelets and bangles</a></li></ul><p><br></p><p><span style="color: black;">- 運送及退貨服務</span></p><ul><li><span style="color: black;">滿新台幣3,500以上的訂單可免費配送</span></li><li><span style="color: black;">享免費退貨服務</span></li></ul></div></div>',
            product_url: "",
            amount: 0,
            discount_rule: null,
            unit: "個",
            remark: {},
            quantity: 0,
            img_url: [
              "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-bc9ce889-4aae-4c0f-9cf2-89d86bb96a99",
            ],
            order: 99999,
            hot_order: 99999,
            spec_groups: [],
            extra_info: null,
            isPeriod: false,
            allowDecimal: false,
            tags: [
              {
                id: 23,
                createtime: "2022-09-21T09:57:44.000Z",
                lastupdate: "2022-09-29T04:11:02.000Z",
                productId: 4638,
                tagId: 486,
                extraInfo: null,
              },
              {
                id: 24,
                createtime: "2022-09-21T09:57:44.000Z",
                lastupdate: "2022-09-29T04:11:02.000Z",
                productId: 4638,
                tagId: 482,
                extraInfo: null,
              },
              {
                id: 25,
                createtime: "2022-09-21T09:57:54.000Z",
                lastupdate: "2022-09-29T04:11:02.000Z",
                productId: 4638,
                tagId: 483,
                extraInfo: null,
              },
              {
                id: 140,
                createtime: "2022-09-29T04:11:02.000Z",
                lastupdate: "2022-09-29T04:11:02.000Z",
                productId: 4638,
                tagId: 510,
                extraInfo: null,
              },
            ],
            spec: {
              id: 10695,
              createtime: "2022-09-15T08:07:11.000Z",
              lastupdate: "2022-09-15T08:43:21.000Z",
              product_id: 4638,
              product_spec_uid: "18 K白金, 鑽石",
              quantity: 10,
              amount: 66500,
              currency: "TWD",
              img_url: null,
              group_item: [],
              group_title: "",
              gtin: null,
              mpn: null,
              extra_info: null,
            },
          },
          discount: { amount: 66500 },
        },
        {
          id: 6926,
          createtime: "2022-09-30T03:03:25.000Z",
          lastupdate: "2022-09-30T03:03:25.000Z",
          order_id: 6436,
          detail_uid: "20220930087643602",
          product_id: 4657,
          spec_id: 10737,
          quantity: 1,
          amount: 8400,
          currency: "TWD",
          product: {
            id: 4657,
            createtime: "2022-09-21T10:25:44.000Z",
            lastupdate: "2022-09-21T10:36:14.000Z",
            shop_id: 87,
            category_id: 1117,
            product_uid: null,
            name: "REFLECT 耳環，大號",
            status: "HOT",
            description:
              "這款耳環由兩個有機形狀的純銀鏈圈打造，帶有鉸鏈扣。 由 Jacqueline Rabun 設計，採用 Reflect 系列的經典鏈節設計，是對經典造型的大膽突破。 配搭其他心喜珠寶作點綴，或作為日常必備款式佩戴。",
            detail:
              '<div class="ql-snow"><div class="ql-editor"><p><span style="color: rgb(159, 154, 141);">9/8~9/19</span></p><p><span style="color: rgb(159, 154, 141);">新品/單鑽除外，結帳輸碼【GJ99】享全館8%回饋</span></p><p><span style="color: rgb(159, 154, 141);">九月購買K金珠寶，加贈GJ時尚行李吊牌(限30組)</span></p><p><br></p><p>這款奢華的 18K 金項錬重新演繹經典鏈式設計，成為任何現代時尚造型的特色所在。 這款項鍊由 Jacqueline Rabun 設計，將設計師的特色與 Georg Jensen 的雕塑設計語言相結合，大膽而吸睛。 可使用內置扣環將其扣緊。</p><p><br></p><p><span style="color: rgb(0, 0, 0);">- 產品詳細說明</span></p><ul><li><span style="color: black;">商品編號：20000686</span></li><li><span style="color: black;">材質：18K黃金</span></li><li><span style="color: black;">外形尺寸：直徑：15.3 毫米。 45 cm 1.1 mm 錨鏈 鍊子長度可以透過環扣調節。</span></li><li><span style="color: black;">設計年份：2020</span></li><li><span style="color: black;">系列：</span><a href="https://www.georgjensen.com/zh-tw/jewellery/mercy" rel="noopener noreferrer" target="_blank" style="color: black;">Mercy系列</a></li><li><span style="color: black;">探索：</span><a href="https://www.georgjensen.com/zh-tw/jewellery/gold-necklace-and-pendants" rel="noopener noreferrer" target="_blank" style="color: black;">Gold necklace and pendants</a><span style="color: black;">, </span><a href="https://www.georgjensen.com/zh-tw/jewellery/gold-jewellery" rel="noopener noreferrer" target="_blank" style="color: black;">K金珠寶</a></li></ul><p><br></p><p><span style="color: black;">- 運送及退貨服務</span></p><ul><li><span style="color: black;">滿新台幣3,500以上的訂單可免費配送</span></li><li><span style="color: black;">享免費退貨服務</span></li></ul></div></div>',
            product_url: "",
            amount: 0,
            discount_rule: null,
            unit: "個",
            remark: {},
            quantity: 0,
            img_url: [
              "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-a113b50e-d9e9-49d0-a47c-db2b19986700",
              "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-6525231b-445b-484c-8534-002dc6b251e4",
            ],
            order: 99999,
            hot_order: 99999,
            spec_groups: [],
            extra_info: null,
            isPeriod: false,
            allowDecimal: false,
            tags: [
              {
                id: 76,
                createtime: "2022-09-22T04:29:56.000Z",
                lastupdate: "2022-09-28T08:17:30.000Z",
                productId: 4657,
                tagId: 483,
                extraInfo: null,
              },
              {
                id: 77,
                createtime: "2022-09-22T04:29:56.000Z",
                lastupdate: "2022-09-28T08:17:30.000Z",
                productId: 4657,
                tagId: 499,
                extraInfo: null,
              },
              {
                id: 89,
                createtime: "2022-09-22T07:23:29.000Z",
                lastupdate: "2022-09-28T08:17:30.000Z",
                productId: 4657,
                tagId: 501,
                extraInfo: null,
              },
              {
                id: 121,
                createtime: "2022-09-27T10:06:00.000Z",
                lastupdate: "2022-09-28T08:17:30.000Z",
                productId: 4657,
                tagId: 510,
                extraInfo: null,
              },
              {
                id: 136,
                createtime: "2022-09-28T08:17:30.000Z",
                lastupdate: "2022-09-28T08:17:30.000Z",
                productId: 4657,
                tagId: 511,
                extraInfo: null,
              },
            ],
            spec: {
              id: 10737,
              createtime: "2022-09-21T10:36:14.000Z",
              lastupdate: "2022-09-21T10:36:14.000Z",
              product_id: 4657,
              product_spec_uid: "純銀",
              quantity: 10,
              amount: 8400,
              currency: "TWD",
              img_url: null,
              group_item: [],
              group_title: "",
              gtin: null,
              mpn: null,
              extra_info: null,
            },
          },
          discount: { amount: 8400 },
        },
      ],
    },
  ],
  tags: [],
};
export const TOWN = require("./town.mock.json");
export const CITY = require("./city.mock.json");

export const liff = {
  error: "",
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getProfile: async () => {
    return {
      userId: "Ub6f15f86e3bb6e9104a8f45b94bbe0b1",
      displayName: "黃卷 Juan",
      statusMessage: "じゅえん",
      pictureUrl:
        "https://profile.line-scdn.net/0hDLs-5EJTG2NeVDCtlt…mNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRlJiYFQyczpRhA",
    };
  },
  getAccessToken: () =>
    "eyJhbGciOiJIUzI1NiJ9.nuxx_6yuf1jVMqluyxDtYlkH3U8n_IGXRKgrmq69beqgJbEUTlxAjVkHcIN0SYuayLDf4ITAuJ4uoSOC3Hv_fHyD139G2w8NIMGLEehZs5CeVzABT2bnB3BZ91vEEuvsaLA6OOBeiy_F8bJ5ZNJXDNMT4btYpcMMhUz0Q05sfEo.AleL8WqHN398ingVdU5fCka40JfJtloVdEiPx5IxC_U",
  isLoggedIn: () => true,
  isInClient: () => false,
  getLanguage: () => "th",
};

export const mockBanner = {
  tagPrefix: "banners", //這個可以不用
  images: [
    {
      imageUrl:
        "https://dak6ovdfbyw15.cloudfront.net/img/722/s00722-f2e31881-2e52-4db4-8bec-3eaf02c3b8d3",
      path: "/icons/1629/list",
      isExternal: false, //default
    },
    {
      imageUrl:
        "https://dak6ovdfbyw15.cloudfront.net/img/5/tco-eshop/Necklaces%20&%20Pendants.png",
      path: "https://www.tiffany.com/",
      isExternal: true,
    },
  ],
};

export const mockCollectionSku = {
  tagPrefix: "禮品",
  sectionTitle: "collection_section_title",
  sectionSubTitle: "collection_section_subTitle",
  tabs: [
    {
      key: "Lock",
      title: "collection_tabs_0_title",
      order: 1,
      collectionTitle: "collection_tabs_0_title",
      collectionDesc: "collection_tabs_0_desc",
      banner: [
        {
          imageUrl:
            "https://dak6ovdfbyw15.cloudfront.net/img/722/tiffany-eshop/icons-t-lock-banner.png",
          path: "/icons/1629/list",
          isExternal: false,
        },
      ],
    },
    {
      key: "T",
      title: "collection_tabs_1_title",
      order: 2,
      collectionTitle: "collection_tabs_1_title",
      collectionDesc: "collection_tabs_1_desc",
      banner: [
        {
          imageUrl:
            "https://dak6ovdfbyw15.cloudfront.net/img/722/tiffany-eshop/icons-t-t-banner.png",
          path: "/icons/1629/list",
          isExternal: false,
        },
      ],
    },
    {
      key: "HardWear",
      title: "collection_tabs_2_title",
      order: 4,
      collectionTitle: "collection_tabs_2_title",
      collectionDesc: "collection_tabs_2_desc",
      banner: [
        {
          imageUrl:
            "https://dak6ovdfbyw15.cloudfront.net/img/722/tiffany-eshop/icons-t-hardwear-banner.png",
          path: "/icons/1629/list",
          isExternal: false,
        },
      ],
    },
    {
      key: "Knot",
      title: "collection_tabs_3_title",
      order: 3,
      collectionTitle: "collection_tabs_3_title",
      collectionDesc: "collection_tabs_3_desc",
      banner: [
        {
          imageUrl:
            "https://dak6ovdfbyw15.cloudfront.net/img/722/tiffany-eshop/icons-t-knot-banner.png",
          path: "/icons/1629/list",
          isExternal: false,
        },
      ],
    },
  ],
};

export const mockCategorySku = {
  tagPrefix: "送禮推薦",
  sectionTitle: "category_section_title",
  sectionSubTitle: "category_section_subTitle",
  tabs: [
    {
      key: "Necklaces",
      title: "category_tabs_0_title",
      order: 1,
      banner: [
        {
          imageUrl:
            "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-c45179f8-abdf-4d96-80fc-80c4178b6710",
          path: null,
          isExternal: null,
        },
      ],
    },
    {
      key: "Earrings",
      title: "category_tabs_1_title",
      order: 2,
      banner: [
        {
          imageUrl:
            "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-62190aae-ac84-460e-89b3-fef99dae98a7",
          path: null,
          isExternal: null,
        },
      ],
    },
    {
      key: "Bracelets",
      title: "category_tabs_2_title",
      order: 3,
      banner: [
        {
          imageUrl:
            "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-f64689b0-3535-432e-aa43-7d2c1feb55c4",
          path: null,
          isExternal: null,
        },
      ],
    },
    {
      key: "Home & Accessories",
      title: "category_tabs_3_title",
      order: 4,
      banner: [
        {
          imageUrl:
            "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-283ffc57-b70d-4800-9aa3-ec7d0469120a",
          path: null,
          isExternal: null,
        },
      ],
    },
  ],
};

export const mockSpecialSku = {
  tagPrefix: "特別活動",
};

export const mockCategory = [
  {
    id: 1117,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Necklaces",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
  {
    id: 1118,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Earrings",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
  {
    id: 1119,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Rings",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
  {
    id: 1120,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Bracelets",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
  {
    id: 1121,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Watches",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
  {
    id: 1122,
    createtime: "2025-09-12T05:58:10.000Z",
    lastupdate: "2025-09-12T06:36:24.000Z",
    shop_id: 208,
    title: "Accessories & Others",
    img_url:
      "https://shopbot-images.s3.us-east-2.amazonaws.com/s153_191016051924748",
    order: 99999,
    status: "ON",
    description: "",
    extraInfo: {},
    tags: [],
  },
];

export const mockCart = {
  carts: [
    {
      productID: 6601,
      specID: 14145,
      quantity: 1,
      product: mockProducts[0],
    },
  ],
  hasRemovedCarts: false,
  products: [mockProducts[0]],
  discounts: [],
  coupons: [],
};
